export default function (obj: any) {
  return JSON.parse(JSON.stringify(obj))
}
